import React from 'react';
import PropTypes from 'prop-types';

const WORDMARK_SRC = `${process.env.PUBLIC_URL}/ADVANTAGE_LOGO.png`;
const SHIELD_SRC = `${process.env.PUBLIC_URL}/android-chrome-192x192.png`;

const sources = {
  wordmark: WORDMARK_SRC,
  shield: SHIELD_SRC,
};

const aspectRatios = {
  wordmark: 1100 / 334,
  shield: 1,
};

export const BrandLogo = ({ variant = 'wordmark', height = 50, className, style, alt = 'USFCR Advantage' }) => (
  <img
    src={sources[variant]}
    width={Math.round(height * aspectRatios[variant])}
    height={height}
    className={className}
    style={style}
    alt={alt}
  />
);

BrandLogo.propTypes = {
  variant: PropTypes.oneOf(['wordmark', 'shield']),
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  alt: PropTypes.string,
};
